import { Select, SelectItem } from "@heroui/react";
import { PROJECT_GRADIENT_OPTIONS, PROJECT_GRADIENTS } from "../../constants/gradients";

/**
 * GradientSelect - Static dropdown for selecting gradient themes
 * Uses NextUI Select with static items (simpler than dynamic pattern).
 */
export const GradientSelect = ({
  label = "Header Gradient",
  name = "header_gradient",
  value,
  onChange,
  required = false,
  disabled = false,
}) => {
  const selectedKey = value ? String(value) : undefined;

  const handleSelectionChange = (keys) => {
    const key = keys?.currentKey || (keys instanceof Set ? [...keys][0] : keys);
    if (onChange && key) {
      onChange({ target: { name, value: key } });
    }
  };

  return (
    <Select
      label={label}
      labelPlacement="inside"
      placeholder="Select a gradient"
      size="sm"
      isRequired={required}
      isDisabled={disabled}
      selectedKeys={selectedKey ? new Set([selectedKey]) : new Set()}
      onSelectionChange={handleSelectionChange}
      classNames={{
        base: "font-sans",
        label: "scale-90 group-data-[focus=true]:-translate-y-2.5 group-data-[focus=true]:scale-75 group-data-[filled=true]:-translate-y-2.5 group-data-[filled=true]:scale-75 font-sans text-grey",
        trigger: "h-12 bg-lightgrey shadow-none rounded-md border border-surface-border data-[hover=true]:!bg-lightgrey data-[focus=true]:!bg-lightgrey",
        value: "text-sm text-darkgrey font-sans",
        listbox: "bg-white",
        popoverContent: "bg-white border border-surface-border rounded-lg shadow-lg",
      }}
      scrollShadowProps={{ isEnabled: false }}
    >
      {PROJECT_GRADIENT_OPTIONS.map((item) => (
        <SelectItem
          key={item.id}
          textValue={item.name}
          classNames={{
            base: "data-[hover=true]:bg-lightgrey data-[selected=true]:bg-secondary/10 data-[selected=true]:text-secondary-dark",
            title: "text-sm text-darkgrey font-sans",
          }}
        >
          <div className="flex items-center gap-2">
            <span
              className={`w-5 h-5 rounded-sm bg-gradient-to-r ${PROJECT_GRADIENTS[item.id] || "from-secondary to-primary"}`}
            />
            <span>{item.name}</span>
          </div>
        </SelectItem>
      ))}
    </Select>
  );
};

export default GradientSelect;
